import React, { useContext } from 'react';
import { FirstCommentView, FirstCommentViewProps } from './FirstComment.view';
import { PostEditorContext } from '../states/PostEditorProvider';
import { PostEditorGroupDataContext } from '../states/PostEditorGroupDataProvider';
import { ActiveCustomizeIndexContext } from '../states/ActiveCustomizeIndexProvider';
import { getTotalHashes } from '../TextEditor/helpers/getTotalHashes';
import { mapSelectedProfilesValues } from '../helpers/mapSelectedProfilesValues';
import { canAddComment } from '../helpers/canAddComment';

export type FirstCommentControllerProps = {
  // extend your FirstCommentViewProps
};

export const FirstCommentController = (props: FirstCommentControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const { state, dispatch, profiles: socialProfiles } = useContext(PostEditorContext);
  const [tabsState] = useContext(PostEditorGroupDataContext);
  const { postGroupIndex } = tabsState;
  const customizeIndex = useContext(ActiveCustomizeIndexContext);
  const postGroup = state.postGroups[postGroupIndex];
  const { customizeContentPerProfile, posts, groupPostAttributes } = postGroup;
  const firstComment =
    customizeContentPerProfile && typeof customizeIndex === 'number'
      ? posts[customizeIndex].content.firstComment
      : groupPostAttributes.content.firstComment;

  const shouldShowFirstComment =
    customizeContentPerProfile && typeof customizeIndex === 'number'
      ? posts[customizeIndex].content.shouldShowFirstComment
      : groupPostAttributes.content.shouldShowFirstComment;

  const selectedProfiles =
    typeof customizeIndex === 'number' && customizeContentPerProfile
      ? socialProfiles.filter(profile => profile.id === posts[customizeIndex].customizedProfileId)
      : mapSelectedProfilesValues(postGroup.profiles, socialProfiles);

  const postFeedType =
    customizeContentPerProfile && typeof customizeIndex === 'number'
      ? posts[customizeIndex].content.postFeedType
      : postGroup.groupPostAttributes.content.postFeedType;

  const showFirstComment = shouldShowFirstComment && canAddComment(selectedProfiles, postFeedType);

  const hasIgSelectedProfiles =
    customizeContentPerProfile &&
    typeof customizeIndex === 'number' &&
    posts[customizeIndex] &&
    posts[customizeIndex].customizedProfileId
      ? !!selectedProfiles.find(
          item => item.id === posts[customizeIndex].customizedProfileId && item.__typename === 'InstagramSocialProfile'
        )
      : selectedProfiles.reduce((prev, current) => {
          if (prev) return prev;
          return current.__typename === 'InstagramSocialProfile';
        }, false);

  const texts =
    typeof customizeIndex === 'number' && customizeContentPerProfile
      ? posts[customizeIndex].content.texts
      : groupPostAttributes.content.texts;

  // const hashesCounterByVariationId = getHashesByVariationId(texts, firstComment);
  // const hashtagCounter = Object.values(hashesCounterByVariationId).map(hashtagTuple => {
  //   return hashtagTuple[0] + hashtagTuple[1];
  // });
  // const hashtagsCount = hasIgSelectedProfiles ? Math.max(...hashtagCounter) : undefined;
  const hashesCounterTuple = getTotalHashes(texts, firstComment);
  const hashtagsCount = hasIgSelectedProfiles ? hashesCounterTuple[0] + hashesCounterTuple[1] : undefined;

  const onRemove = () => {
    dispatch({
      type: 'toggleFirstComment',
      payload: {
        customizeIndex,
        postGroupIndex,
        selectedProfiles
      }
    });
  };

  const viewProps: FirstCommentViewProps = {
    ...props,
    onRemove,
    firstComment,
    hashtagsCount
  };
  return showFirstComment ? <FirstCommentView {...viewProps} /> : <></>;
};
